export const setInventoryPolicyToVariants = ({ variants, inventoryPolicy }) =>
  variants.map(variant => ({
    ...variant,
    inventory_policy: inventoryPolicy,
  }));
